<h2 mat-dialog-title>Configurações</h2>
<mat-dialog-content>
    <form [formGroup]="form" (submit)="submit()" autocomplete="off">
        <span>Abaixo é exibida a lista de processos seletivos que foram removidos da exibição.<br>
             Escolha uma opção para restaurar a forma de exibição:
        </span>
        <div class="row" style="margin-top: 10px;">
            <mat-form-field appearance="outline">
                <mat-label>Processo Seletivos</mat-label>
                <mat-select formControlName="selectedProcess" class="form-control">
                <mat-option *ngFor="let listprocess of process" [value]="listprocess.id">
                    {{ listprocess.name }}
                </mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('selectedProcess').errors?.required">
                Por favor escolha uma opção
                </mat-error>
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>
<mat-progress-bar *ngIf="submiting"></mat-progress-bar>
<mat-dialog-actions *ngIf="!submiting">
    <button color="accent" mat-button mat-dialog-close>Cancelar</button>
  <button
    class="custom-primary"
    color="primary"
    mat-raised-button
    type="submit"
    [disabled]="!form.valid"
    (click)="submit()"
  >
    Salvar
  </button>
</mat-dialog-actions>